import * as React from 'react';

function SvgJapan(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.73h35.537V0H0v20.73z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.77 4.148a6.216 6.216 0 016.217 6.217c0 3.432-2.782 6.225-6.217 6.225a6.226 6.226 0 01-6.22-6.225 6.22 6.22 0 016.22-6.217z"
        fill="#AD0018"
      />
    </svg>
  );
}

export default SvgJapan;
